/**
 *
 * Header
 *
 */

import React, { ReactNode } from 'react';

interface HeaderProps {
  children: ReactNode; // ReactNode includes all valid React children types
}

const Header: React.FC<HeaderProps> = ({ children }) => {
  return (
    <div className="sticky-top navbar-light">
      {children}
    </div>
  );
};

export default Header;
